module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-11-0c674d9d9d17342f608629a894ef76ce.webp";